"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var SButton = styled_components_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-weight: 500;\n  padding: 13px 23px;\n  border-radius: 3px;\n  border: 1px solid #2362a2;\n  letter-spacing: 0.05em;\n  box-shadow: 0 1px 3px rgba(0, 82, 133, 0.2);\n  color: #2362a2;\n  background-color: #ffffff;\n  cursor: pointer;\n\n  ", "\n\n  ", "\n\n  ", "\n    ", "\n"], ["\n  text-transform: uppercase;\n  font-weight: 500;\n  padding: 13px 23px;\n  border-radius: 3px;\n  border: 1px solid #2362a2;\n  letter-spacing: 0.05em;\n  box-shadow: 0 1px 3px rgba(0, 82, 133, 0.2);\n  color: #2362a2;\n  background-color: #ffffff;\n  cursor: pointer;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n    ",
    "\n"])), function (_a) {
    var $primary = _a.$primary;
    return $primary && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: #ffffff;\n      background-color: #2362a2;\n\n      &:active {\n        background-color: #016496;\n      }\n    "], ["\n      color: #ffffff;\n      background-color: #2362a2;\n\n      &:active {\n        background-color: #016496;\n      }\n    "])));
}, function (_a) {
    var $loading = _a.$loading;
    return $loading && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      opacity: 0.8;\n    "], ["\n      opacity: 0.8;\n    "])));
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: #eff3f4;\n      border-color: #eff3f4;\n      color: black;\n    "], ["\n      background-color: #eff3f4;\n      border-color: #eff3f4;\n      color: black;\n    "])));
}, function (_a) {
    var warning = _a.warning;
    return warning && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background-color: #fe505d;\n      border-color: #fe505d;\n      color: white;\n    "], ["\n      background-color: #fe505d;\n      border-color: #fe505d;\n      color: white;\n    "])));
});
var LoadingIcon = styled_components_1.default(icons_1.LoadingOutlined)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-right: 1em;\n"], ["\n  margin-right: 1em;\n"])));
var Button = function (_a) {
    var type = _a.type, className = _a.className, children = _a.children, onClick = _a.onClick, primary = _a.primary, loading = _a.loading, disabled = _a.disabled, name = _a.name, warning = _a.warning;
    return (react_1.default.createElement(SButton, { type: type === 'submit' ? 'submit' : 'button', className: className, onClick: onClick, disabled: loading || disabled, "$loading": loading, "$primary": primary, name: name, warning: warning },
        loading && react_1.default.createElement(LoadingIcon, { spin: true }),
        children));
};
Button.defaultProps = {
    children: undefined,
    className: undefined,
    onClick: undefined,
    primary: false,
    loading: false,
    type: 'button',
    disabled: undefined,
    warning: false,
};
exports.default = Button;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
